import styled from 'styled-components';

export const StyledBgImage = styled.img`
  width: 100%;
`;
